import React, { useState, useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { ShopGrid, ShopGridSkeleton } from "../../modules/Shop/ShopGrid";
import * as apiCampioni from "../../api/campioni";
import * as apiRichieste from "../../api/richieste";
import { roles } from "../../config/config";

export const ShopCampioni = ({ elements }) => {
  const [loading, setLoading] = useState(false);
  const [campioni, setCampioni] = useState([]);

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  const updateFromServer = async () => {
    setLoading(true);
        let samplesData = {};
        
        if (role === roles.admin || role === roles.gestore ||
          role === roles.developer || 
          role === roles.grafico || 
          role === roles.magazziniere || 
          role === roles.dipendente) {
          samplesData = await apiCampioni.getAll(user.authToken);
        } else {
        samplesData = await apiCampioni.getCampioniByUserTargets(user.authToken)
        }
      
        setCampioni(
          samplesData.map((c) => ({
            id: c.id,
            name: c.name,
            qta: c.qta,
            description: c.description,
            division: c.division,
            imageUrl: c.image,
            quantity: c.quantity,
            cost: c.price,
            available: c.available,
          }))
        );
      
      setLoading(false);
  };

  useEffect(() => {
    updateFromServer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !loading ? (
    <ShopGrid
      key="shop-campioni"
      elements={campioni}
      cartName="campioni"
      displayName="campioni"
      //elements={[...campioni, mockCampioni]}
      maxDescriptionLength={50}
      imageHeight={150}
      api={apiRichieste}
      richiediExtra={true}
      redirectTo="/status-campionatura-servizi#campioni"
    />)
    : (<ShopGridSkeleton />);
};
